import './Projects.css'
import React from 'react';
import Project from '../Project/Project';
import projects from '../../projects-data'

const Projects = () => {
    return (
        <div className='projects' id='projects'>
            <h1 className="projects-title">
                <span>Latest Projects</span>
            </h1>
            <div className="project-grid">
                {
                    // projects.map(project => <Project />)
                    projects.map((project, index) => <Project key={index} {...project} />)
                }
            </div>
        </div>
    );
};

export default Projects;